<template>
  <div
    class="drag_wrapper"
    ref="dragRef"
    :style="{top:pos.y+'px', left:pos.x+'px'}"
    @mousemove="onTouchMove"
    @touchstart="getTouchstartY"
    @touchmove.stop="onTouchMove"
  >
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'FloatingBall',
    props: {
      position: {
        type: Object,
        default: () => (
         { x: 300, y: 500,})
      },
      right: {
        type: Number,
        default: 10
      },
      bottom: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        startY: null,
        flags: false,
        maxX: 0,
        maxY: 0,
        pos: {x: 0,y: 0, },
     };
    },
    mounted() {
      //设置默认值
      this.pos = { ...this.$props.position };
      // 获取容器元素的尺寸信息
      const rect = this.$refs.dragRef.getBoundingClientRect();
      // 获取容器元素尺寸的一半便于后面计算使用
      this.wrapperHalfWidth = rect.width / 2;
      this.wrapperHalfHeight = rect.height / 2;
      // 获取屏幕的尺寸信息
      const clientWidth =document.body.clientWidth || document.documentElement.clientWidth;
      const clientHeight =document.body.clientHeight || document.documentElement.clientHeight;
      // 获取拖拽元素在屏幕内可拖拽的边界值
      this.maxX = clientWidth - rect.width;
      this.maxY = clientHeight - rect.height - 50; // -50是减掉底部tab bar高度
      this.pos.x = this.pos.x ? this.pos.x : this.maxX - this.right;
      this.pos.y = this.pos.y ? this.pos.y : this.maxY - this.bottom;
    },
    methods: {
      getTouchstartY(event) {
        this.startY = event.changedTouches[0].pageY  //将手指对应的y轴坐标赋值给data中的startY
      },
      onTouchMove(event) {
        // 获取触点，兼容PC和移动端
        let touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        if(this.startY === touch.pageY) { // 点击事件不作处理
          return;
        }
        // 定位滑块的位置
        this.pos.x = touch.clientX - this.wrapperHalfWidth;
        this.pos.y = touch.clientY - this.wrapperHalfHeight;
        // 处理边界
        if (this.pos.x <= 0) {
          this.pos.x = 0;
        } else if (this.pos.x > this.maxX) {
          this.pos.x = this.maxX;
        }
        if (this.pos.y  <= 0) {
          this.pos.y = 0;
        } else if (this.pos.y > this.maxY) {
          this.pos.y = this.maxY;
        }
        // 阻止页面的滑动默认事件
        event.preventDefault();
      },
    },
  }
</script>

<style scoped>
  .drag_wrapper {
    position: fixed;
    z-index: 50;
  }
</style>
